import TextArea, { TextAreaProps } from "ds_legacy/components/TextArea";
import { FormElement, FormElementProps } from "react-forms-state";

export default FormElement()<FormElementProps & TextAreaProps>(TextArea);
